var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tw-text-origami-sm tw-font-bold" },
    [_vm._t("breakDetails")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }